import { z } from 'zod';

export const UuidSchema = z.string().uuid();
export type Uuid = z.infer<typeof UuidSchema>;

export const SlugSchema = z
  .string()
  .regex(/^[a-z0-9-]{3,40}$/, 'slug must be lowercase alphanumeric, 3-40 chars');

export const HexColorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/);

export const IsoDateTimeSchema = z.string().datetime({ offset: true });
export const IsoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const CountryCodeSchema = z.string().length(2).toUpperCase();
export const LanguageCodeSchema = z.string().regex(/^[a-z]{2,3}$/);

export const HttpUrlSchema = z.string().url().refine((u) => /^https?:\/\//i.test(u), {
  message: 'must be http(s) URL',
});

export const NonEmptyTrimmedSchema = z.string().trim().min(1);

/** Request context resolved by middleware and attached to every authenticated handler. */
export interface RequestContext {
  userId: Uuid;
  tenantId: Uuid;
  role: MemberRole;
  requestId: string;
  flags: Record<string, boolean>;
}

export type MemberRole = 'owner' | 'admin' | 'strategist' | 'viewer';

export const MemberRoleSchema = z.enum(['owner', 'admin', 'strategist', 'viewer']);

export type PlanTier = 'trial' | 'audit' | 'content' | 'copilot';
export const PlanTierSchema = z.enum(['trial', 'audit', 'content', 'copilot']);

export type TenantStatus = 'active' | 'suspended' | 'cancelled';
export const TenantStatusSchema = z.enum(['active', 'suspended', 'cancelled']);

export type DeliveryChannel = 'markdown' | 'pdf' | 'google_docs' | 'notion';
export const DeliveryChannelSchema = z.enum(['markdown', 'pdf', 'google_docs', 'notion']);

export type Severity = 'critical' | 'high' | 'medium' | 'low';
export const SeveritySchema = z.enum(['critical', 'high', 'medium', 'low']);

export type Bucket = 'technical' | 'on_page' | 'performance' | 'content' | 'indexing';
export const BucketSchema = z.enum(['technical', 'on_page', 'performance', 'content', 'indexing']);

export type Intent = 'informational' | 'navigational' | 'commercial' | 'transactional';
export const IntentSchema = z.enum([
  'informational',
  'navigational',
  'commercial',
  'transactional',
]);
